export const Services = {
    LOADING_SERVICES_LIST: "LOADING_SERVICES_LIST",
    GET_SERVICES_LIST: "GET_SERVICES_LIST",
  };